import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { ExploreServiceState } from '../redux/exploreServiceSlice';
import useTrailEngagementRecordIds from './useTrailEngagementRecordIds';

const filterIsObject = (obj: any) => {
  // Check if it's a non-null object
  if (typeof obj !== 'object' || obj === null) {
    return false;
  }

  // Check if its prototype is the default Object prototype
  const proto = Object.getPrototypeOf(obj);
  return proto === null || proto === Object.prototype;
};

export default function useExploreServiceFilterCounts() {
  const { adminFilters, distanceAwayIsochrone, filters, trailEngagement } = useSelector(
    (state: { exploreService: ExploreServiceState }) => state.exploreService
  );

  const recordIds = useTrailEngagementRecordIds(trailEngagement);

  const filterCount = useMemo(() => {
    let count = 0;

    if (recordIds) {
      count += recordIds.length;
    }

    Object.values(filters).forEach(filter => {
      if (filterIsObject(filter)) {
        count += Object.keys(filter).length;
      } else if (Array.isArray(filter)) {
        count += filter.length;
      } else {
        count += 1;
      }
    });
    if (distanceAwayIsochrone) {
      count += 1;
    }
    return count;
  }, [distanceAwayIsochrone, filters, recordIds]);

  const adminFilterCount = useMemo(() => {
    return Object.keys(adminFilters).length;
  }, [adminFilters]);

  return useMemo(() => ({ adminFilterCount, filterCount }), [adminFilterCount, filterCount]);
}
